/**
 * JANIMONY.CHAT - useAuth Hook
 * Custom hook for authentication
 */

import { useState, useEffect } from 'react';
import AuthService from '../services/auth';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const currentUser = AuthService.getCurrentUser();
    setUser(currentUser);
    setLoading(false);
  }, []);

  const login = (userData, token) => {
    AuthService.setUser(userData, token);
    setUser(userData);
  };

  const logout = () => {
    AuthService.logout();
    setUser(null);
  };

  return {
    user,
    loading,
    login,
    logout,
    isAuthenticated: AuthService.isAuthenticated()
  };
};